module.exports = __webpack_public_path__ + "static/media/yangan.1f49c1d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/yangan.mp3
// module id = +SIW
// module chunks = 208